const EMAIL_APPOINTMENT_ID_SESSION_KEY = 'scheduler-email-appointment-id';

export const persistEmailAppointmentId = (appointmentId: string) => {
  sessionStorage.setItem(EMAIL_APPOINTMENT_ID_SESSION_KEY, appointmentId);
};

export const getPersistedEmailAppointmentId = (): string | null =>
  sessionStorage.getItem(EMAIL_APPOINTMENT_ID_SESSION_KEY);

export const clearPersistedEmailAppointmentId = () => {
  sessionStorage.removeItem(EMAIL_APPOINTMENT_ID_SESSION_KEY);
};

export const isEmailAppointmentStateIncomplete = (state: {
  appointmentId?: string;
  confirmedAppointment?: {
    agentInfo?: {
      resourceId?: string;
    };
  };
}): boolean =>
  !state.appointmentId ||
  !state.confirmedAppointment?.agentInfo?.resourceId;
